import React from 'react';
import { FretNumberSelector } from '../features/fretboard-config/FretNumberSelector';
import { HeightRatioSelector } from '../features/fretboard-config/HeightRatioSelector';
import { InstrumentSelector } from '../features/fretboard-config/InstrumentSelector';
import { TuningSelector } from '../features/fretboard-config/TuningSelector';
import { FretSpacingSelector } from '../features/fretboard-config/FretSpacingSelector';
import { FretWidthBaseSelector } from '../features/fretboard-config/FretWidthBaseSelector';
import { HandednessSelector } from '../features/fretboard-config/HandednessSelector';
import { TrapezoidScalingSelector } from '../features/fretboard-config/TrapezoidScalingSelector';
import { ThemeSelector } from '../features/theme/ThemeSelector';
import { FretMarkerLabelsSelector } from '../features/fretboard-config/FretMarkerLabelsSelector';
import { NoteCircleScaleSelector } from '../features/fretboard-config/NoteCircleScaleSelector';

export const SettingsDrawer: React.FC = () => {
  return (
    <div className="drawer-side z-20">
      <label
        htmlFor="settings-drawer"
        aria-label="close sidebar"
        className="drawer-overlay"
      ></label>
      <div className="p-4 w-80 min-h-full bg-base-200 text-base-content overflow-x-hidden">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-xl font-bold">Settings</h2>
          <label htmlFor="settings-drawer" className="btn btn-sm btn-circle">
            ✕
          </label>
        </div>

        {/* Settings groups in accordions */}
        <div className="join join-vertical w-full">
          {/* Theme selector accordion */}
          <div className="collapse collapse-arrow join-item border border-base-300">
            <input type="radio" name="settings-accordion" />
            <div className="collapse-title text-lg font-medium">Appearance</div>
            <div className="collapse-content pr-3 overflow-x-hidden">
              <ThemeSelector />
            </div>
          </div>

          {/* Instrument Setup accordion */}
          <div className="collapse collapse-arrow join-item border border-base-300">
            <input type="radio" name="settings-accordion" defaultChecked />
            <div className="collapse-title text-lg font-medium">Instrument Setup</div>
            <div className="collapse-content pr-3 overflow-x-hidden">
              <InstrumentSelector />
              <TuningSelector />
              <HandednessSelector />
            </div>
          </div>

          {/* Fretboard Display accordion */}
          <div className="collapse collapse-arrow join-item border border-base-300">
            <input type="radio" name="settings-accordion" />
            <div className="collapse-title text-lg font-medium">Fretboard Display</div>
            <div className="collapse-content pr-3 overflow-x-hidden">
              <FretNumberSelector />
              <HeightRatioSelector />
              <FretWidthBaseSelector />
              <NoteCircleScaleSelector />
              <TrapezoidScalingSelector />
              <FretSpacingSelector />
              <FretMarkerLabelsSelector />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
